import React from 'react';

const CustomCheckbox = ({ customClass, type, onChange, value, title, description, register, name, checked, defaultChecked, error, disabled = false }) => {
  const classMain = `wizard__checkbox ${customClass || ''}`;

  return (
    <label className={classMain}>
      <div className="wizard__checkbox-info">
        <span className="wizard__checkbox-title">{title}</span>
        <span className="wizard__secondary-txt">{description}</span>
      </div>
      {register ? (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          ref={register}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      )}
      <span className={`checkmark ${error ? 'checkmark_error' : ''}`} />
    </label>
  );
};

export default CustomCheckbox;
